<div class="container-pagina-app" [class.hidden]="menuOculto">
  <!-- <div class="container-menu" [class.hidden]="menuOculto" [style.background-image]="'linear-gradient(to bottom, ' + colorMenu + ' -33%, ' + ajustarColor(colorMenu, -50) + ')'"> -->
  <div class="container-menu" [class.hidden]="menuOculto" >
    <div class="container-superior-menu">
      <img class="imagen-menu" alt="Logo Proptech" [src]="logo" />
      <ul class="container-items-menu">
        <ng-container *ngFor="let item of itemsMenu">
          <li
            class="item-menu"
            [ngClass]="this.itemSelected === item ? 'item-seleccionado' : ''"
            (click)="onClick(item, item.url)"
            *ngIf="item.permisos.includes(rolUsuario)" 
          >
            <img src="{{ item.icono }}" alt="Icono Item Menu" />
            <span>{{ item.titulo }}</span>
          </li>
        </ng-container>
      </ul>
    </div>
    <button class="boton-inferior-menu" (click)="onCerrarSesion()">
      Cerrar Sesión
    </button>
  </div>
  <div class="container-contenido-pagina">
    <div class="contenido-minimo">
      <app-header></app-header>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
